export const UNPLUGGED = 'UNPLUGGED';
export const CHARGING = 'CHARGING';
export const CHARGED = 'CHARGED';
export const READY_TO_USE = 'READY_TO_USE';
export const CLEANING = 'CLEANING';
export const UNCHARGED = 'UNCHARGED';
